var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    transform: "matrix(-1 0 0 1 44 0)",
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9757 11.6375C25.1132 11.6375 28.4757 15 28.4757 19.1375V22.75C28.4757 23.5125 28.8007 24.6749 29.1882 25.3249L30.6257 27.7125C31.5132 29.1875 30.9007 30.825 29.2757 31.375C23.8882 33.175 18.0757 33.175 12.6882 31.375C11.1757 30.875 10.5132 29.0875 11.3382 27.7125L12.7757 25.3249C13.1507 24.6749 13.4757 23.5125 13.4757 22.75V19.1375C13.4757 15.0125 16.8507 11.6375 20.9757 11.6375Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6621 12C19.0496 11.8875 19.4496 11.8 19.8621 11.75C21.0621 11.6 22.2121 11.6875 23.2871 12C22.9246 11.075 22.0246 10.425 20.9746 10.425C19.9246 10.425 19.0246 11.075 18.6621 12Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2246 31.825C17.2246 33.8875 18.9121 35.575 20.9746 35.575C21.9996 35.575 22.9496 35.15 23.6246 34.475C24.2996 33.8 24.7246 32.85 24.7246 31.825",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a4c54d2af5186ef3ef4bffaad16e73ae.svg";
export { ForwardRef as ReactComponent };